import { render, staticRenderFns } from "./GlobalViolationsReport.vue?vue&type=template&id=a1c0f100&scoped=true"
import script from "./GlobalViolationsReport.vue?vue&type=script&lang=js"
export * from "./GlobalViolationsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c0f100",
  null
  
)

export default component.exports